import { Link, useNavigate } from '@tanstack/react-router';

import { ApiForm, Field, Submit, TextInput, useApiForm } from '../../shared/form';
import { login, signInSchema, type TSignIn } from '../../entities/session';
import { SIGNED_OUT_MESSAGE } from '../../shared/api/errors';
import { Note } from '../../shared/ui/note';
import { AuthScreen } from './ui/auth-screen';

export const SignInPage = ({ next, signedOut }: { next?: string; signedOut?: boolean }) => {
  const navigate = useNavigate();

  const api = useApiForm<TSignIn>({
    schema: signInSchema,
    defaultValues: { email: '', password: '' },
    onSubmit: async (values) => {
      await login(values);
      await navigate({ to: next ?? '/flows' });
    },
  });

  return (
    <AuthScreen
      title="Sign in"
      description="Your work email and your password."
      footer={
        <>
          No account yet?{' '}
          <Link to="/register" className="text-accent">
            Create one
          </Link>
        </>
      }
    >
      {signedOut && (
        <Note tone="caution" className="mt-section">
          {SIGNED_OUT_MESSAGE}
        </Note>
      )}
      <ApiForm api={api} flush={signedOut} className={signedOut ? 'mt-6' : undefined}>
        <Field<TSignIn> name="email" label="Email">
          <TextInput type="email" autoComplete="email" placeholder="pavel@rawnodes.dev" />
        </Field>

        <Field<TSignIn>
          name="password"
          label="Password"
          aside={
            <Link to="/auth/reset-password" className="text-meta text-muted">
              Forgot password?
            </Link>
          }
        >
          <TextInput type="password" autoComplete="current-password" placeholder="••••••••••••" />
        </Field>

        <Submit waitingLabel="Checking">Sign in</Submit>
      </ApiForm>
    </AuthScreen>
  );
};
